import { useMultipleEtfMarketReactionLines } from './hooks/useMultipleEtfMarketReactionLines';
import { MarketCatalystReactionChartView } from './MarketCatalystReactionChartView';
import { BaseMarketCatalystReactionProps } from './market-catalyst-reaction.types';

export const MultipleEtfMarketCatalystReaction = ({
  tags,
  tickers,
  createdAt,
  leftHeaderNode,
}: BaseMarketCatalystReactionProps) => {
  const { lines, fromDateEST, toDateEST, isDailyFallback, isLoading } =
    useMultipleEtfMarketReactionLines({ tags, tickers, createdAt });

  return (
    <MarketCatalystReactionChartView
      isLoading={isLoading}
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={lines}
      leftHeaderNode={leftHeaderNode}
      isDailyFallback={isDailyFallback}
    />
  );
};
